export default __webpack_public_path__ + "63a61f8fa95af26d06191e3904271653.svg";